import { render, staticRenderFns } from "./BlogWithSlider.vue?vue&type=template&id=faea7b1a&scoped=true&"
import script from "./BlogWithSlider.vue?vue&type=script&lang=js&"
export * from "./BlogWithSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faea7b1a",
  null
  
)

export default component.exports